import { useMediaQuery, useTheme } from '@mui/material';

// Единый порог "мобильной" верстки для всего приложения.
// md = 900, lg = 1200
export const APP_MOBILE_BREAKPOINT = 'lg';

export function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(APP_MOBILE_BREAKPOINT));
}

